import React from "react";
import { ExternalLink, HelpCircle } from "lucide-react";
import { useParams } from "react-router-dom";
import "./ExternalSurvey.css";

const ExternalSurvey = () => {
  const { eventId } = useParams();

  // TODO: Replace with actual survey link from configuration or API
  const surveyUrl = "https://bit.ly/BFFConfFeedback";

  return (
    <div className="external-survey-page">
      <div className="survey-card">
        <div className="icon-container">
          <HelpCircle size={48} className="survey-icon" />
        </div>
        <h1>We Value Your Feedback</h1>
        <p>
          Please take a few moments to share your thoughts about the conference.
          Your feedback helps us improve future events.
        </p>

        <a
          href={surveyUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="survey-button"
        >
          <span>Take the Survey</span>
          <ExternalLink size={20} />
        </a>

        <p className="sub-text">Link opens in a new tab</p>
      </div>
    </div>
  );
};

export default ExternalSurvey;
